angular.module('storefrontApp')
    .component('vcPaymentMethods', {
        templateUrl: 'themes/assets/js/common-components/paymentMethods.tpl.html',
        bindings: {
            getAvailPaymentMethods: '&',
            onSelectMethod: '&',
            paymentMethod: '=',
            validationContainer: '=',
        },
        controller: ['$scope', function ($scope) { // eslint-disable-line no-unused-vars
            const ctrl = this;

            this.$onInit = function () {
                ctrl.loading = true;

                ctrl.getAvailPaymentMethods()
                    .then(function (methods) {
                        ctrl.availPaymentMethods = _.sortBy(methods, function (x) {
                            return x.priority;
                        });
                        if (ctrl.paymentMethod) {
                            // eslint-disable-next-line no-multi-assign
                            ctrl.paymentMethod = ctrl.method = _.findWhere(ctrl.availPaymentMethods, {
                                code: ctrl.paymentMethod.code,
                            });
                        }
                        if (!ctrl.paymentMethod && ctrl.availPaymentMethods.length > 0) {
                            const method = ctrl.availPaymentMethods
                                .find((x) => x.code === 'Authorize.NetCreditCardBank') || ctrl.availPaymentMethods[0];
                            ctrl.method = method;
                            ctrl.selectMethod(method);
                        }
                        ctrl.loading = false;
                    });

                if (ctrl.validationContainer) {
                    ctrl.validationContainer.addComponent(this);
                }
            };

            this.$onDestroy = function () {
                if (ctrl.validationContainer) {
                    ctrl.validationContainer.removeComponent(this);
                }
            };

            ctrl.validate = function () {
                return !!ctrl.paymentMethod;
            };

            ctrl.selectMethod = function (method) {
                const paymentMethod = angular.copy(method);

                ctrl.paymentMethod = paymentMethod;
                ctrl.onSelectMethod({ paymentMethod });
            };
        }],
    });
